import { shapeEntity } from '../shapeEntity';
import treeApi, { treeApiInstance } from './tree.api';
import treeState from './tree.state';

export default shapeEntity('Tree', {
    api: treeApiInstance,
    ...treeApi,
    useState: treeState,
});
